var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',{staticClass:"prism-editor",attrs:{"label":_vm.$attrs.label,"disabled":_vm.$attrs.disabled}},[_c('prism-editor',_vm._b({staticClass:"prism-editor__field",attrs:{"highlight":_vm.highlighter},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'prism-editor',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }